import { decodeText } from "../../lib/react-util";

export const normalizeHtml = html => {
  if (!html || !html) {
    return "";
  }
  // Replace file paths with the correct API endpoint
  let current = html.replace(
    /=(&quot;|"|')\/cp\/cpdata\/uploads/g || /=(&quot;|"|')\/cp\/cpdata\/simplifica-chile-uploads/g,
    `=$1${process.env.REACT_APP_FILES_API}`,
  );
  // Decode HTML entities
  current = decodeText(current);
  // Remove unnecessary quotes
  current = current.replace(/&quot;/g, "");
  return current;
};

export const parseData = data => {
  if (!data || data.length === 0) {
    return {
      headerAlternatives: [],
      questions: [],
    }
  }
  const questions = data.flatMap(d => (d.context ? d.context.questions : [d.question ?? d]));
  const maxNumberOfAlternatives = Math.max(
    ...questions.map(question => question.alternatives?.length || 0),
  );
  if (maxNumberOfAlternatives === 0) {
    return {
      headerAlternatives: [],
      questions: parseQuestions({questions, headerAlternatives: []}),
    }
  }
  const headerAlternatives = Array(maxNumberOfAlternatives)
      .fill(null)
      .map((_, index) => ({
        id: index + 1,
      }));
  return {
    headerAlternatives,
    questions: parseQuestions({questions, headerAlternatives}),
  }
};

export const parseQuestions = ({questions, headerAlternatives}) => {
  if (!questions || !Array.isArray(questions)) {
    return [];
  }
  return questions.map((question, questionIndex) => {
    const { text, alternatives } = question;
    const html = normalizeHtml(text);
    const parsedAlternatives = headerAlternatives.map((_, alternativeIndex) => {
        const alternative = alternatives[alternativeIndex] || {};
        return {
          id: alternative.id,
          html: normalizeHtml(alternative.text),
          checked: alternative.checked
        };
      });

    return {
      id: question.id,
      html,
      alternatives: parsedAlternatives,
    };
  });
};
